import axios from 'axios'
import {APIDOC} from 'config/apiurl'
import moment from 'moment'
import QueryString from 'qs'
import {toCurrency} from 'utils/functions'

/** Usia seperti PHP date_diff: y Th m Bln */
export const getUsiaFromTglLahir = pastgllahir => {
  if (!pastgllahir) return null
  const awal = moment(pastgllahir)
  if (!awal.isValid()) return null
  const akhir = moment()
  const thn = akhir.diff(awal, 'years')
  const bln = akhir.diff(awal.clone().add(thn, 'years'), 'months')
  return {thn, bln}
}

export const formatWbln = pastgllahir => {
  const usia = getUsiaFromTglLahir(pastgllahir)
  if (!usia) return '-'
  return `${usia.thn} Th ${usia.bln} Bln`
}

/** Tanggal lahir cetak: "04 Jun 2026 / 30 Th 5 Bln" (seperti PHP d M Y / wbln) */
export const formatTanggalLahirCetak = pastgllahir => {
  if (!pastgllahir) return '-'
  const tgl = moment(pastgllahir)
  if (!tgl.isValid()) return '-'
  return `${tgl.format('DD MMM YYYY')} / ${formatWbln(pastgllahir)}`
}

/** Cetak resep: 1 → "1", 1.2 → "1.2" (titik desimal, tanpa nol di belakang). */
export const formatCetakJumlah = value => {
  if (value == null || value === '') return '-'
  const num = parseFloat(`${value}`.trim().replace(',', '.'))
  if (Number.isNaN(num)) return `${value}`
  return num.toFixed(10).replace(/\.?0+$/, '')
}

const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b))

/** Cetak gidion (custom Imelda): 1.5 → "1 1/2", 1.2 → "1 1/5", 2.5 → "2 1/2". */
export const formatCetakJumlahGidion = value => {
  if (value == null || value === '') return '-'
  const num = parseFloat(`${value}`.trim().replace(',', '.'))
  if (Number.isNaN(num)) return `${value}`

  const rounded = Math.round(num * 10) / 10
  const whole = Math.floor(rounded)
  const tenths = Math.round((rounded - whole) * 10)

  if (tenths === 0) return String(whole)

  let numerator = tenths
  let denominator = 10
  const g = gcd(numerator, denominator)
  numerator /= g
  denominator /= g

  if (whole === 0) return `${numerator}/${denominator}`
  return `${whole} ${numerator}/${denominator}`
}

export const fetchCetak = (dctid, id) => {
  const getIdentitas = async () => {
    try {
      const {data: res} = await axios.post(
        `${APIDOC}/ap-user-dokter/get-profil-by-id`,
        QueryString.stringify({
          uid: dctid,
          a: 'dk13',
        })
      )

      if (res.status == 1) return res.data
      return {e: true}
    } catch (error) {
      return {e: true}
    }
  }

  const getStg = async () => {
    try {
      const {data: res} = await axios.post(
        `${APIDOC}/prd-pengaturan-resep/get-stg`,
        QueryString.stringify({
          uid: dctid,
        })
      )

      if (res.status == 1) return res.data
      return {e: true}
    } catch (error) {
      return {e: true}
    }
  }

  const getDetail = async () => {
    const params = QueryString.stringify({id})
    try {
      const {data} = await axios.post(
        APIDOC + '/prd-lap-penjualan-resep/detail',
        params
      )

      if (data.status === 1)
        return {head: data.dataHead, child: data.dataDetail}
      return {e: true}
    } catch (e) {
      return {e: true}
    }
  }

  return Promise.all([getStg(), getIdentitas(), getDetail()])
    .then(([stg, identitas, detail]) => {
      if (stg?.e || identitas?.e || detail?.e) return {e: true}
      return {stg, identitas, detail}
    })

    .catch(err => ({e: true}))
}
